export default __webpack_public_path__ + "static/media/rappro.3c25518d.jpg";